export default {"src":"/_next/static/media/fullscreen.2610c9b3.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};